function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WFS_ID_KEY } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';

/**
 * Share style for selected features
 */
var SELECTED_STYLE = {
  inherit: true,
  effect: 'auto major',
  stroke: {
    area: {
      effect: 'none',
      color: '#000000',
      width: 4
    },
    width: 3
  }
};
export var SelectionHelper = /*#__PURE__*/function () {
  function SelectionHelper(layerPlugin) {
    _classCallCheck(this, SelectionHelper);
    this._layerPlugin = layerPlugin;
    // layerId: { fid: olFeature }
    this._styledFeatures = {};
  }
  return _createClass(SelectionHelper, [{
    key: "getMapModule",
    value: function getMapModule() {
      return this._layerPlugin.getMapModule();
    }
  }, {
    key: "updateSelection",
    value: function updateSelection(oskariLayer) {
      var _this = this;
      var featureIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var layerId = oskariLayer.getId();
      var currentSelection = this._getStyledFeaturesByLayer(layerId);
      Object.keys(currentSelection).filter(function (fid) {
        return !featureIds.includes(fid);
      }).forEach(function (fid) {
        return _this._removeStyleFromFeature(layerId, fid);
      });
      var newSelection = this.getFeaturesByIds(layerId, featureIds);
      if (!newSelection.length) {
        return;
      }
      var style = this.getMapModule().getStyleForLayer(oskariLayer, SELECTED_STYLE);
      newSelection.forEach(function (feature) {
        return _this._setStyleForFeature(layerId, feature, style);
      });
    }
    // recalculate styles for currently selected features on layer
  }, {
    key: "updateSelectionStyles",
    value: function updateSelectionStyles(oskariLayer) {
      var _this2 = this;
      var layerId = oskariLayer.getId();
      var style = this.getMapModule().getStyleForLayer(oskariLayer, SELECTED_STYLE);
      var styledFeatures = this._getStyledFeaturesByLayer(layerId);
      Object.keys(styledFeatures).forEach(function (fid) {
        return _this2._setStyleForFeature(layerId, styledFeatures[fid], style);
      });
    }
  }, {
    key: "getFeaturesByIds",
    value: function getFeaturesByIds(layerId, featureIds) {
      var olLayers = this.getMapModule().getOLMapLayers(layerId);
      if (!olLayers || !olLayers.length || typeof olLayers[0].getSource !== 'function') {
        return [];
      }
      var source = olLayers[0].getSource();
      return featureIds.map(function (fid) {
        return source.getFeatureById(fid);
      }).filter(function (f) {
        return !!f;
      }); // remove null values if feature isn't found
    }
  }, {
    key: "_saveFeatureRef",
    value: function _saveFeatureRef(layerId, olFeature) {
      var features = this._styledFeatures[layerId];
      if (!features) {
        features = {};
        this._styledFeatures[layerId] = features;
      }
      features[olFeature.get(WFS_ID_KEY)] = olFeature;
    }
  }, {
    key: "_getStyledFeaturesByLayer",
    value: function _getStyledFeaturesByLayer(layerId) {
      return this._styledFeatures[layerId] || {};
    }
  }, {
    key: "_setStyleForFeature",
    value: function _setStyleForFeature(layerId, olFeature, style) {
      olFeature.setStyle(style);
      this._saveFeatureRef(layerId, olFeature);
    }
  }, {
    key: "_removeStyleFromFeature",
    value: function _removeStyleFromFeature(layerId, featureId) {
      var styledFeatures = this._getStyledFeaturesByLayer(layerId);
      var feature = styledFeatures[featureId];
      if (!feature) {
        return;
      }
      feature.setStyle();
      delete styledFeatures[featureId];
    }
  }]);
}();
;